<app-modal
  [title]="'Non taken reservations to release'| trans:'non-taken-reservations-to-release-modal/header/title'"
  maxWidth="1000px"
>
  <ng-template>
    @if (isLoading()) {
      <div class="d-flex justify-content-center full-height align-items-center">
        <app-loader size="lg" />
      </div>
    } @else {
      @if (shows.length > 0) {
        <table class="base full-width table-layout-fixed">
          <thead>
          <tr>
            <th width="20%">
              {{ 'Kundenkarte'| trans:'non-taken-reservations-to-release-modal/table/customerCard.Label' }}
            </th>
            <th width="20%">
              {{ 'Saal'| trans:'non-taken-reservations-to-release-modal/table/auditorium.Label' }}
            </th>
            <th width="20%">
              {{ 'Start'| trans:'non-taken-reservations-to-release-modal/table/begin.Label' }}
            </th>
            <th width="20%">
              {{ 'Vortsellung'| trans:'non-taken-reservations-to-release-modal/table/event.Label' }}
            </th>
            <th width="20%">
              {{ 'Release date'| trans:'non-taken-reservations-to-release-modal/table/releaseDate.Label' }}
            </th>
          </tr>
          </thead>
          <tbody>
            @for (show of shows; track i; let i = $index;) {
              <tr
                class="selectable-tr cursor-pointer"
                [class.selected]="selectedShows.has(i)"
                (click)="selectedShows.has(i) ? selectedShows.delete(i) : selectedShows.set(i, show)"
              >
                <td>
                  <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                    {{ show.isFreeReservationCC ? ('Ja' | trans:'non-taken-reservations-to-release-modal/table/cc.Yes') : ('Nein' | trans:'non-taken-reservations-to-release-modal/table/cc.No') }}
                  </div>
                </td>

                <td>
                  <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                    {{ show.show.auditorium.name }}
                  </div>
                </td>

                <td>
                  <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                    {{ show.show.beginning | localeDatetimeFormat }}
                  </div>
                </td>

                <td>
                  <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                    {{ show.show.title }}
                  </div>
                </td>

                <td>
                  <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                    {{ (show.isFreeReservationCC ? show.show.freeReservationCC : show.show.freeReservation) | localeDatetimeFormat }}
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <p>{{ 'No shows found.' | trans:'non-taken-reservations-to-release-modal/noShowsFound.Text' }}</p>
      }
    }
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Close'| trans:'non-taken-reservations-to-release-modal/close.Button' }}
      </button>

      <button
        #btn
        class="button button--md button--primary text-uppercase"
        [disabled]="selectedShows.size === 0"
        (click)="confirmReleaseReservations(btn)"
      >
        {{ 'Confirm'| trans:'non-taken-reservations-to-release-modal/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
